/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingMetricAccessAssignment {
    getFixupPrototypeFunction() { return BillingMetricAccessAssignment.fixupPrototype; }

    static newInstance(model: Partial<BillingMetricAccessAssignment>): BillingMetricAccessAssignment {
        let obj = Object.assign(new BillingMetricAccessAssignment(), model);
        BillingMetricAccessAssignment.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingMetricAccessAssignment>): BillingMetricAccessAssignment {
        if (!model) return null;
        return BillingMetricAccessAssignment.newInstance(<BillingMetricAccessAssignment> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingMetricAccessAssignment) {
        if (!obj) return;

        models.BillingMetricAccessAssignment.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingMetricAccessAssignment): boolean {
        Object.setPrototypeOf(obj, BillingMetricAccessAssignment.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.details) {
            for (let val of this.details) {
                models.BillingMetricAccess.fixupPrototype(val);
            }
        }
    }

    /**
     * Master account ID
     */
    master_account_id: string;

    /**
     * Metric wise RBAC assignment details
     */
    details: Array<models.BillingMetricAccess>;

}
